import { useState } from 'react';

const EditableText = ({
  id,
  name,
  type='text',
  value='', 
  onChange, 
  style,
  displayStyle
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value || '');

  // 편집 시작
  const handleClick = () => {
    setTempValue(value || '');
    setIsEditing(true);
  };

  // 편집 완료
  const handleComplete = async () => {
    if (tempValue !== value) {
      try {
        await onChange(tempValue);
        console.log(`${id || name || ''} 업데이트 완료: ${value} -> ${tempValue}`);
      } catch (error) {
        //console.error(`${id || name || ''} 업데이트 실패:`, error);
        alert(`${id || name || ''} 업데이트에 실패했습니다.`);
        setTempValue(value || ''); // 실패 시 원래 값으로 복원
      }
    }
    setIsEditing(false);
  };

  // 편집 취소
  const handleCancel = () => {
    setTempValue(value || '');
    setIsEditing(false);
  };

  // 키보드 이벤트
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleComplete();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  // 값 변경
  const handleChange = (e) => {
    setTempValue(e.target.value);
  };

  if (isEditing) {
    return (
      <input
        type={type}
        value={tempValue}
        onChange={handleChange}
        onBlur={handleComplete}
        onKeyDown={handleKeyDown}
        autoFocus
        style={style}
      />
    );
  }

  return (
    <div
      onClick={handleClick}
      style={displayStyle}
      title="클릭하여 수정"
    >
      {value}
    </div>
  );
};

export default EditableText;